import { useState } from "react";
import { toast } from "sonner";
import { Copy, Link2Off, Share2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { inputCls, btnPrimary, btnSecondary } from "@/components/shared";

export const shareUrl = (token) => `${window.location.origin}/w/${token}`;

export const ShareWishlistDialog = ({ open, onOpenChange, list, onChange }) => {
  const [busy, setBusy] = useState(false);
  const run = async (method) => {
    setBusy(true);
    try {
      onChange((await api[method](`/shop-lists/${list.id}/share`)).data);
      if (method === "delete") toast("Link turned off. Old links no longer work.");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  const copy = async () => {
    const url = shareUrl(list.share_token);
    try {
      if (navigator.share) await navigator.share({ title: list.name, url });
      else {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied");
      }
    } catch {
      // user closed the share sheet
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="bg-t-bg border-t-line rounded-2xl sm:max-w-lg" data-testid={`share-dialog-${list.id}`}>
        <DialogHeader><DialogTitle className="font-serif-display text-3xl font-semibold">Share "{list.name}"</DialogTitle></DialogHeader>
        <p className="text-sm text-t-muted">Anyone with the private link can view this wishlist. They can't see your other lists or change anything.</p>
        {list.share_token ? (
          <div className="space-y-4">
            <input readOnly data-testid="share-link-input" className={inputCls} value={shareUrl(list.share_token)} onFocus={(e) => e.target.select()} />
            <div className="flex gap-3">
              <button data-testid="share-copy-button" onClick={copy} className={`${btnPrimary} flex-1`}><Copy className="h-4 w-4" /> Copy or send link</button>
              <button data-testid="share-revoke-button" disabled={busy} onClick={() => run("delete")} className={`${btnSecondary} text-t-danger`}><Link2Off className="h-4 w-4" /> Stop sharing</button>
            </div>
          </div>
        ) : (
          <button data-testid="share-create-button" disabled={busy} onClick={() => run("post")} className={`${btnPrimary} w-full`}><Share2 className="h-4 w-4" /> Create private link</button>
        )}
      </DialogContent>
    </Dialog>
  );
};
